import SvgIcon, { IconProps } from './SvgIcon';
import React from 'react';

export default function SortDescIcon(props: IconProps) {
  return (
    <SvgIcon {...props}>
      <path d="M4 3H8.42109C9.35119 3 9.81624 3 9.94012 3.28013C10.064 3.56026 9.74755 3.89632 9.11466 4.56842L5.47691 8.43158C4.84402 9.10368 4.52757 9.43974 4.65145 9.71987C4.77533 10 5.24038 10 6.17048 10H10" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M4 21L6.10557 16.3053C6.49585 15.4351 6.69098 15 7 15C7.30902 15 7.50415 15.4351 7.89443 16.3053L10 21" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M17.5 20V4M17.5 20C16.7998 20 15.4915 18.0057 15 17.5M17.5 20C18.2002 20 19.5085 18.0057 20 17.5" strokeLinecap="round" strokeLinejoin="round" />
    </SvgIcon>
  );
}


